import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Tab, Tabs, Typography} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import {useMemo, memo} from "react";
import SeriesGroupOutputs from "./GroupOutputs";
import DraggableDialogTitle from '../../../../common/DraggableDialogTitle'
import { ExtraSmallButton } from "../../../../custom";

export type ConfigurationPopupProps = {
    open: boolean
    onClose: () => void
    chartId: string
}

const ConfigurationPopup: React.FC<ConfigurationPopupProps> = ({ open, onClose, chartId }) => {
    const tabs = useMemo(() => (
        <Tabs value="styles" sx={{ width: '100%', overflowX: 'auto', display: 'flex' }}>
            <Tab label="Styles" value="styles" />
        </Tabs>
    ), [])

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DraggableDialogTitle>
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant={'h6'}>{"Styles"}</Typography>
                    <ExtraSmallButton color="inherit" onClick={onClose} aria-label="close"
                                sx={{ height: 'fit-content' }}>
                        <CloseOutlined />
                    </ExtraSmallButton>
                </Box>
                {tabs}
                <Divider />
            </DraggableDialogTitle>
            <DialogContent sx={{ width: '100%' }}>
                <SeriesGroupOutputs chartId={chartId} />
            </DialogContent>
            <DialogActions sx={{ borderTop: 1, borderColor: 'divider' }}>
                <Button variant="contained" onClick={onClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default memo(ConfigurationPopup)
